import { useCallback, useMemo, useRef, useState } from 'react'

import './index.scss'
import Button from '../Button'
import { useTranslation } from 'react-i18next'
import DropDownSelection from '../DropdownSelection'
import { useClickOutside } from '../../hooks/useClickOutside'
import { useNavigate } from 'react-router-dom'
import { COLOR } from '../../data/variables'
import { ICON } from '../Icon/data'
import Icon from '../Icon'

const AdminToolsWidget = () => {
  const { t } = useTranslation()
  const dropdownRef = useRef()
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const label = useMemo(() => {
    return (
      <div className="AdminToolsWidget__label">
        {t('Admin tools')}
        <Icon icon={ICON.USER_ADMIN} size={16} color={isOpen ? COLOR.WHITE : COLOR.TEXT_GRAY} />
      </div>
    )
  }, [t, isOpen])

  const navigateToPage = useCallback((path: string) => {
    navigate(path)
    setIsOpen(false)
  }, [navigate])

  const options = [{
    label: t('Manage fleets'),
    icon: ICON.CARS,
    onClick: () => {
      navigateToPage('/manage/fleet')
    }
  }, {
    label: t('Manage mobiles'),
    icon: ICON.COGWHEEL,
    onClick: () => {
      navigateToPage('/manage/mobiles')
    }
  }, {
    label: t('Sensor temperature settings'),
    icon: ICON.SENSOR_TEMPERATURE,
    onClick: () => {
      navigateToPage('/manage/sensors')
    }
  }, {
    label: t('Manage users'),
    icon: ICON.USERS_MULTIPLE,
    onClick: () => {
      navigateToPage('/manage/users')
    }
  }]

  return (
    <div className="AdminToolsWidget">
      <Button
        label={label}
        size="s" type="tertiary"
        onClick={() => setIsOpen(!isOpen)}
        isActive={isOpen}
      />
      {isOpen && (
        <div ref={dropdownRef} className="AdminToolsWidget__dropdown">
          <DropDownSelection options={options} />
        </div>
      )}
    </div>
  )
}

export default AdminToolsWidget
